export const isPeriodActive = (period, now = new Date()) => {
    if (!period) return false;
    const startRaw = period?.period?.start ?? period?.start ?? null;
    const endRaw = period?.period?.end ?? period?.end ?? null;

    const start = startRaw ? new Date(startRaw) : null;
    const end = endRaw ? new Date(endRaw) : null;

    const hasValidStart = !!start && !isNaN(start);
    if (!hasValidStart) return false;

    const startPassed = start <= now;
    const endFutureOrOpen = !end || (end && !isNaN(end) && end >= now);

    return startPassed && endFutureOrOpen;
};

export const hasActiveTenancy = (tenant, now = new Date()) => {
    if (!tenant || !Array.isArray(tenant.tenancies)) return false;
    for (const tenancy of tenant.tenancies) {
        if (!Array.isArray(tenancy.rentalPeriods)) continue;
        if (tenancy.rentalPeriods.some(rp => isPeriodActive(rp, now))) return true;
    }
    return false;
};

export const filterActiveTenants = (tenants, now = new Date()) => {
    if (!Array.isArray(tenants)) return [];
    return tenants.filter(t => hasActiveTenancy(t, now));
};

export const filterInactiveTenants = (tenants, now = new Date()) => {
    if (!Array.isArray(tenants)) return [];
    return tenants.filter(t => !hasActiveTenancy(t, now));
};
